import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB1j_MPvkfx6D1fh4qk-yVkS8IqP_RVFmA",
  authDomain: "zencon-contact-us.firebaseapp.com",
  projectId: "zencon-contact-us",
  storageBucket: "zencon-contact-us.firebasestorage.app",
  messagingSenderId: "555543538592",
  appId: "1:555543538592:web:16107fa81877fb02edd2c5",
  measurementId: "G-JH39FRHSHS",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
